const betbyList = [
  {
    link: '/sportsbook?bt-path=/soccer-1',
    name: {
      'en-US': 'Soccer',
      'ja-JP': 'サッカー',
      'ko-KR': '축구',
      'es-MX': 'Fútbol',
      'pt-BR': 'Futebol',
      'zh-CN': '足球',
    },
    isBonus: false,
    status: 1,
    level: 1,
    isGame: false,
    icon: 'betby/Soccer',
  },
  {
    link: '/sportsbook?bt-path=/basketball-2',
    name: {
      'en-US': 'Basketball',
      'ja-JP': 'バスケットボール',
      'ko-KR': '농구',
      'es-MX': 'Baloncesto',
      'pt-BR': 'Basquete',
      'zh-CN': '篮球',
    },
    isBonus: false,
    status: 1,
    level: 1,
    isGame: false,
    icon: 'betby/Basketball',
  },
  {
    link: '/sportsbook?bt-path=/baseball-3',
    name: {
      'en-US': 'Baseball',
      'ja-JP': '野球',
      'ko-KR': '야구',
      'es-MX': 'Béisbol',
      'pt-BR': 'Beisebol',
      'zh-CN': '棒球',
    },
    isBonus: false,
    status: 1,
    level: 1,
    isGame: false,
    icon: 'betby/Baseball',
  },
  {
    link: '/sportsbook?bt-path=/volleyball-23',
    name: {
      'en-US': 'Volleyball',
      'ja-JP': 'バレーボール',
      'ko-KR': '배구',
      'es-MX': 'Voleibol',
      'pt-BR': 'Vôlei',
      'zh-CN': '排球',
    },
    isBonus: false,
    status: 1,
    level: 1,
    isGame: false,
    icon: 'betby/Volleyball',
  },
  {
    link: '/sportsbook?bt-path=/counter-strike-109',
    name: {
      'en-US': 'Counter-Strike',
      'ja-JP': 'カウンターストライク',
      'ko-KR': '카운터 스트라이크',
      'es-MX': 'Counter-Strike',
      'pt-BR': 'Counter-Strike',
      'zh-CN': '反恐精英',
    },
    isBonus: false,
    status: 1,
    level: 1,
    isGame: false,
    icon: 'betby/eShooter',
  },
  {
    link: '/sportsbook?bt-path=/dota-2-111',
    name: {
      'en-US': 'Dota 2',
      'ja-JP': 'Dota 2',
      'ko-KR': '도타 2',
      'es-MX': 'Dota 2',
      'pt-BR': 'Dota 2',
      'zh-CN': '刀塔 2',
    },
    isBonus: false,
    status: 1,
    level: 1,
    isGame: false,
    icon: 'betby/Dota 2',
  },
  {
    link: '/sportsbook?bt-path=/tennis-5',
    name: {
      'en-US': 'Tennis',
      'ja-JP': 'テニス',
      'ko-KR': '테니스',
      'es-MX': 'Tenis',
      'pt-BR': 'Tênis',
      'zh-CN': '网球',
    },
    isBonus: false,
    status: 1,
    level: 1,
    isGame: false,
    icon: 'betby/Tennis',
  },
  {
    link: '/sportsbook?bt-path=/ice-hockey-4',
    name: {
      'en-US': 'Ice Hockey',
      'ja-JP': 'アイスホッケー',
      'ko-KR': '아이스 하키',
      'es-MX': 'Hockey sobre hielo',
      'pt-BR': 'Hóquei no gelo',
      'zh-CN': '冰上曲棍球',
    },
    isBonus: false,
    status: 1,
    level: 1,
    isGame: false,
    icon: 'betby/Ice Hockey',
  },
  {
    link: '/sportsbook?bt-path=/american-football-16',
    name: {
      'en-US': 'American Football',
      'ja-JP': 'アメリカンフットボール',
      'ko-KR': '미식축구',
      'es-MX': 'Fútbol Americano',
      'pt-BR': 'Futebol Americano',
      'zh-CN': '美式橄榄球',
    },
    isBonus: false,
    status: 1,
    level: 1,
    isGame: false,
    icon: 'betby/American Football',
  },
  {
    link: '/sportsbook?bt-path=/esoccer-300',
    name: {
      'en-US': 'eSoccer',
      'ja-JP': 'eサッカー',
      'ko-KR': 'e축구',
      'es-MX': 'eSoccer',
      'pt-BR': 'eSoccer',
      'zh-CN': '电竞足球',
    },
    isBonus: false,
    status: 1,
    level: 1,
    isGame: false,
    icon: 'betby/eSoccer',
  },
  {
    link: '/sportsbook?bt-path=/mixed-martial-arts-117',
    name: {
      'en-US': 'MMA',
      'ja-JP': 'MMA',
      'ko-KR': 'MMA',
      'es-MX': 'MMA',
      'pt-BR': 'MMA',
      'zh-CN': 'MMA 综合格斗',
    },
    isBonus: false,
    status: 1,
    level: 1,
    isGame: false,
    icon: 'betby/MMA',
  },
  {
    link: '/sportsbook?bt-path=/handball-6',
    name: {
      'en-US': 'Handball',
      'ja-JP': 'ハンドボール',
      'ko-KR': '핸드볼',
      'es-MX': 'Balonmano',
      'pt-BR': 'Handebol',
      'zh-CN': '手球',
    },
    isBonus: false,
    status: 1,
    level: 1,
    isGame: false,
    icon: 'betby/Handball',
  },
  // --- 以下為暫時停用的類別 ---
  // {
  //   link: '/sportsbook?bt-path=/live',
  //   name: {
  //     'en-US': 'Live',
  //     'ja-JP': 'ライブ',
  //     'ko-KR': '라이브',
  //     'es-MX': 'En vivo',
  //     'pt-BR': 'Ao vivo',
  //     'zh-CN': '直播',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/LIVE',
  // },
  // {
  //   link: '/sportsbook?bt-path=/favorites',
  //   name: {
  //     'en-US': 'Favourites',
  //     'ja-JP': 'お気に入り',
  //     'ko-KR': '즐겨찾기',
  //     'es-MX': 'Favoritos',
  //     'pt-BR': 'Favoritos',
  //     'zh-CN': '收藏',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Favourites',
  // },
  // {
  //   link: '/sportsbook?bt-path=/cricket-21',
  //   name: {
  //     'en-US': 'Cricket',
  //     'ja-JP': 'クリケット',
  //     'ko-KR': '크리켓',
  //     'es-MX': 'Críquet',
  //     'pt-BR': 'Críquete',
  //     'zh-CN': '板球',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Cricket',
  // },
  // {
  //   link: '/sportsbook?bt-path=/fifa-300',
  //   name: {
  //     'en-US': 'FIFA',
  //     'ja-JP': 'FIFA',
  //     'ko-KR': 'FIFA',
  //     'es-MX': 'FIFA',
  //     'pt-BR': 'FIFA',
  //     'zh-CN': 'FIFA',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/FIFA 24',
  // },
  // {
  //   link: '/sportsbook?bt-path=/fifa22-volta-309',
  //   name: {
  //     'en-US': 'FIFA22 Volta',
  //     'ja-JP': 'FIFA22 ヴォルタ',
  //     'ko-KR': 'FIFA22 볼타',
  //     'es-MX': 'FIFA22 Volta',
  //     'pt-BR': 'FIFA22 Volta',
  //     'zh-CN': 'FIFA22 Volta',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/FIFA Volta',
  // },
  // {
  //   link: '/sportsbook?bt-path=/table-tennis-20',
  //   name: {
  //     'en-US': 'Table Tennis',
  //     'ja-JP': '卓球',
  //     'ko-KR': '탁구',
  //     'es-MX': 'Tenis de mesa',
  //     'pt-BR': 'Tênis de mesa',
  //     'zh-CN': '乒乓球',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Table Tennis',
  // },
  // {
  //   link: '/sportsbook?bt-path=/floorball-7',
  //   name: {
  //     'en-US': 'Floorball',
  //     'ja-JP': 'フロアボール',
  //     'ko-KR': '플로어볼',
  //     'es-MX': 'Floorball',
  //     'pt-BR': 'Floorball',
  //     'zh-CN': '地板球',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Floorball',
  // },
  // {
  //   link: '/sportsbook?bt-path=/golf-9',
  //   name: {
  //     'en-US': 'Golf',
  //     'ja-JP': 'ゴルフ',
  //     'ko-KR': '골프',
  //     'es-MX': 'Golf',
  //     'pt-BR': 'Golfe',
  //     'zh-CN': '高尔夫',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Golf',
  // },
  // {
  //   link: '/sportsbook?bt-path=/boxing-10',
  //   name: {
  //     'en-US': 'Boxing',
  //     'ja-JP': 'ボクシング',
  //     'ko-KR': '복싱',
  //     'es-MX': 'Boxeo',
  //     'pt-BR': 'Boxe',
  //     'zh-CN': '拳击',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Boxing',
  // },
  // {
  //   link: '/sportsbook?bt-path=/rugby-12',
  //   name: {
  //     'en-US': 'Rugby',
  //     'ja-JP': 'ラグビー',
  //     'ko-KR': '럭비',
  //     'es-MX': 'Rugby',
  //     'pt-BR': 'Rugby',
  //     'zh-CN': '橄榄球',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Rugby',
  // },
  // {
  //   link: '/sportsbook?bt-path=/aussie-rules-13',
  //   name: {
  //     'en-US': 'Aussie Rules',
  //     'ja-JP': 'オージールールズ',
  //     'ko-KR': '오지 룰스',
  //     'es-MX': 'Reglas Australianas',
  //     'pt-BR': 'Regras Australianas',
  //     'zh-CN': '澳式足球',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Aussie Rules',
  // },
  // {
  //   link: '/sportsbook?bt-path=/cycling-17',
  //   name: {
  //     'en-US': 'Cycling',
  //     'ja-JP': 'サイクリング',
  //     'ko-KR': '사이클링',
  //     'es-MX': 'Ciclismo',
  //     'pt-BR': 'Ciclismo',
  //     'zh-CN': '自行车',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   image: '',
  //   icon: 'betby/Cycling',
  // },
  // {
  //   link: '/sportsbook?bt-path=/specials-18',
  //   name: {
  //     'en-US': 'Specials',
  //     'ja-JP': 'スペシャルズ',
  //     'ko-KR': '스페셜스',
  //     'es-MX': 'Especiales',
  //     'pt-BR': 'Especiais',
  //     'zh-CN': '特别',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Specials',
  // },
  // {
  //   link: '/sportsbook?bt-path=/snooker-19',
  //   name: {
  //     'en-US': 'Snooker',
  //     'ja-JP': 'スヌーカー',
  //     'ko-KR': '스누커',
  //     'es-MX': 'Snooker',
  //     'pt-BR': 'Snooker',
  //     'zh-CN': '斯诺克',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Snooker',
  // },
  // {
  //   link: '/sportsbook?bt-path=/darts-22',
  //   name: {
  //     'en-US': 'Darts',
  //     'ja-JP': 'ダーツ',
  //     'ko-KR': '다트',
  //     'es-MX': 'Dardos',
  //     'pt-BR': 'Dardos',
  //     'zh-CN': '飞镖',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Darts',
  // },
  // {
  //   link: '/sportsbook?bt-path=/waterpolo-26',
  //   name: {
  //     'en-US': 'Waterpolo',
  //     'ja-JP': 'ウォーターポロ',
  //     'ko-KR': '수상포로',
  //     'es-MX': 'Waterpolo',
  //     'pt-BR': 'Polo aquático',
  //     'zh-CN': '水球',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Waterpolo',
  // },
  // {
  //   link: '/sportsbook?bt-path=/futsal-29',
  //   name: {
  //     'en-US': 'Futsal',
  //     'ja-JP': 'フットサル',
  //     'ko-KR': '풋살',
  //     'es-MX': 'Fútbol sala',
  //     'pt-BR': 'Futsal',
  //     'zh-CN': '五人足球',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Futsal',
  // },
  // {
  //   link: '/sportsbook?bt-path=/formula-1-40',
  //   name: {
  //     'en-US': 'Formula 1',
  //     'ja-JP': 'フォーミュラ 1',
  //     'ko-KR': '포뮬라 1',
  //     'es-MX': 'Fórmula 1',
  //     'pt-BR': 'Fórmula 1',
  //     'zh-CN': '一级方程式',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Formula 1',
  // },
  // {
  //   link: '/sportsbook?bt-path=/alpine-skiing-43',
  //   name: {
  //     'en-US': 'Alpine Skiing',
  //     'ja-JP': 'アルペンスキー',
  //     'ko-KR': '알파인 스키',
  //     'es-MX': 'Esquí alpino',
  //     'pt-BR': 'Esqui alpino',
  //     'zh-CN': '高山滑雪',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Alpine Skiing',
  // },
  // {
  //   link: '/sportsbook?bt-path=/biathlon-44',
  //   name: {
  //     'en-US': 'Biathlon',
  //     'ja-JP': 'バイアスロン',
  //     'ko-KR': '바이애슬론',
  //     'es-MX': 'Biatlón',
  //     'pt-BR': 'Biatlo',
  //     'zh-CN': '双项北欧',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Biathlon',
  // },
  // {
  //   link: '/sportsbook?bt-path=/speedway-131',
  //   name: {
  //     'en-US': 'Speedway',
  //     'ja-JP': 'スピードウェイ',
  //     'ko-KR': '스피드웨이',
  //     'es-MX': 'Speedway',
  //     'pt-BR': 'Speedway',
  //     'zh-CN': '赛车',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Speedway',
  // },
  // {
  //   link: '/sportsbook?bt-path=/gaelic-football-135',
  //   name: {
  //     'en-US': 'Gaelic Football',
  //     'ja-JP': 'ゲーリックフットボール',
  //     'ko-KR': '게일릭 풋볼',
  //     'es-MX': 'Fútbol Gaélico',
  //     'pt-BR': 'Futebol Gaélico',
  //     'zh-CN': '盖尔足球',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/Gaelic Football',
  // },
  // {
  //   link: '/sportsbook?bt-path=/Frocket-league-301',
  //   name: {
  //     'en-US': 'Frocket League',
  //     'ja-JP': 'フロケットリーグ',
  //     'ko-KR': '프로켓 리그',
  //     'es-MX': 'Frocket League',
  //     'pt-BR': 'Frocket League',
  //     'zh-CN': 'Frocket League',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   // icon: 'betby/Frocket League',
  // },
  // {
  //   link: '/sportsbook?bt-path=/nba-2k19-302',
  //   name: {
  //     'en-US': 'NBA 2k19',
  //     'ja-JP': 'NBA 2k19',
  //     'ko-KR': 'NBA 2k19',
  //     'es-MX': 'NBA 2k19',
  //     'pt-BR': 'NBA 2k19',
  //     'zh-CN': 'NBA 2k19',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/NBA 2K',
  // },
  // {
  //   link: '/sportsbook?bt-path=/efighting-304',
  //   name: {
  //     'en-US': 'Efighting',
  //     'ja-JP': 'Eファイティング',
  //     'ko-KR': 'E파이팅',
  //     'es-MX': 'Efighting',
  //     'pt-BR': 'Efighting',
  //     'zh-CN': 'Efighting',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/eFighting',
  // },
  // {
  //   link: '/sportsbook?bt-path=/ecricket-305',
  //   name: {
  //     'en-US': 'Ecricket',
  //     'ja-JP': 'Eクリケット',
  //     'ko-KR': 'E크리켓',
  //     'es-MX': 'Ecricket',
  //     'pt-BR': 'Ecricket',
  //     'zh-CN': 'Ecricket',
  //   },
  //   isBonus: false,
  //   status: 1,
  //   level: 1,
  //   isGame: false,
  //   icon: 'betby/eCricket',
  // },
]

export default betbyList
